// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-shadow{box-shadow:0 10px 10px -5px rgba(55,65,81,.04),0 20px 25px -5px rgba(55,65,81,.1)}.blurred-background{background-image:linear-gradient(180deg,hsla(0,0%,98.8%,.72) 1.82%,#fcfcfc 99.6%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
